import { apiUrl } from '../constants/apiConsts';
import fetchRequest from '../utils/request';
import { getHeaders } from './helpers';

class WorshipLocationApi {
  static getWorshipLocations({ search = '' }) {
    const request = new Request(`${apiUrl}/content/worship-locations/all?search=${search}`, {
      method: 'GET',
      headers: getHeaders(),
    });

    return fetchRequest(request);
  }

  static getWorshipLocationById(id) {
    const request = new Request(`${apiUrl}/content/worship-locations/${id}`, {
      method: 'GET',
      headers: getHeaders(),
    });

    return fetchRequest(request);
  }
}

export default WorshipLocationApi;
